import React, {useState, useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import {v4 as uuidv4} from 'uuid';
import {defaultErrorHandler, orgId} from '../../context/context';
import customFormsV2Client from '../../infrastructure/acerill/custom-forms-v2-client';
import emailV1Client from '../../infrastructure/acerill/email-v1-client';
import Section from '../../libs/react-components-admin/section/section';
import CenteredSpinner from '../../libs/react-components-admin/spinners/centered-spinner';
import SubSection from '../../libs/react-components-admin/section/sub-section';
import InfoBox from '../../libs/react-components-admin/box/info-box';
import DeleteButton from '../../libs/react-components-admin/buttons/delete-button';
import NamedEntityList from '../../libs/react-components-admin/entity/named-entity-list';

const SmtpConfigs = () => {

  const navigate = useNavigate();
  const [entities, setEntities] = useState();

  useEffect(
    () => {
      emailV1Client.findSmtpConfigSummaries()
        .then(e => setEntities(e))
        .catch(err => defaultErrorHandler(err));
    },
    []
  );

  const goTo = id => new Promise(resolve => {
    navigate(`/smtp-configs/${encodeURIComponent(id)}?shop=${encodeURIComponent(orgId)}`);
    resolve();
  });

  return !entities ?
    <CenteredSpinner/> :
    <NamedEntityList entities={entities}
                     addButtonLabel={entities.length === 0 ? 'Create SMTP configuration' : null}
                     addAction={() => goTo(uuidv4())}
                     editAction={id => goTo(id)}
                     deleteAction={id => emailV1Client.deleteSmtpConfig(id)
                       .then(() => setEntities(entities.filter(e => e.id !== id)))
                     }
                     errorHandler={defaultErrorHandler}/>;
};

const FormNotifications = ({form}) => {

  const navigate = useNavigate();

  const [notifications, setNotifications] = useState(form.notifications || []);

  const goToNotification = id => {
    navigate(`/forms/${encodeURIComponent(form.id)}/notifications/${encodeURIComponent(id)}?shop=${encodeURIComponent(orgId)}`);
  };

  const deleteNotification = id => {
    return customFormsV2Client.deleteFormNotification(form.id, id)
      .then(() => setNotifications(notifications.filter(n => n.id !== id)))
  }

  return <SubSection title={form.name || ''} className="mb-4">
    <ul className="list-group">
      {notifications.map(notification =>
      <li key={notification.id} className="list-group-item">
        <div className="row align-items-center">
          <div className="col">
            {notification.name}
          </div>
          <div className="col-auto">
            <button type="button"
                    className="btn btn-sm btn-primary px-4"
                    onClick={() => goToNotification(notification.id)}>
              Edit
            </button>
          </div>
          <div className="col-auto">
            <DeleteButton action={() => deleteNotification(notification.id)}
                          errorHandler={defaultErrorHandler}/>
          </div>
        </div>
      </li>
      )}
      <li className="list-group-item">
        <div className="row">
          <div className="col">
          </div>
          <div className="col-auto">
            <button type="button"
                    className="btn btn-sm btn-success"
                    onClick={() => goToNotification(uuidv4())}>
              {(form.notifications || []).length > 0 ?
                <span className="material-icons align-middle">&#xE145;</span> :
                <span>Create a notification</span>
              }
            </button>
          </div>
        </div>
      </li>
    </ul>
  </SubSection>;
};

const Notifications = () => {

  const [forms, setForms] = useState();

  useEffect(() => {
    customFormsV2Client.findAllForms(true)
      .then(forms => setForms(forms))
      .catch(err => defaultErrorHandler(err));
  }, []);

  return <>
    <Section title="SMTP settings" noMargin={true}>
      <div className="text-muted mb-1">
        To send emails from your own email address:
        <ul>
          <li>google &quot;SMTP configuration for <i>your_email_provider</i>&quot;</li>
          <li>click on &apos;Create SMTP configuration&apos; below and enter the details specific to your email provider</li>
        </ul>
      </div>
      <div className="row justify-content-center">
        <div className="col-12 col-md-8">
          <SmtpConfigs/>
        </div>
      </div>
    </Section>
    <Section title="Notifications" noMargin={true}>
      <div className="text-muted mb-1">
        Notifications allow you to send an email to {/* you or */}your customer when a form is submitted.
      </div>
      <InfoBox>
        <span className="material-icons align-bottom">&#xE88E;</span> Notifications are only sent for forms displayed on a standalone page.<br />
      </InfoBox>
      <div className="row justify-content-center">
        <div className="col-12 col-md-8">
          {!forms ?
            <CenteredSpinner/> :
            forms.sort((f1, f2) => (f1.name || '').localeCompare(f2.name || ''))
              .map(form => <FormNotifications key={form.id} form={form}/>)
          }
        </div>
      </div>
    </Section>
  </>;
};

export default Notifications;